import { render, staticRenderFns } from "./TheBanner.vue?vue&type=template&id=28a03d31&scoped=true&"
import script from "./TheBanner.vue?vue&type=script&lang=js&"
export * from "./TheBanner.vue?vue&type=script&lang=js&"
import style0 from "./TheBanner.vue?vue&type=style&index=0&id=28a03d31&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a03d31",
  null
  
)

export default component.exports